module.exports={
    "over_size_message":"Размер загруженного вами изображения превышает 10MB. Мы сожмем ваш файл для загрузки. Нажмите «Подтвердить», чтобы продолжить загрузку.",
    "file_type_error":"Загруженный вами файл не является изображением! Пожалуйста, попробуйте загрузить снова.",
    "upload_error":"Ошибка загрузки! (Код ошибки: 2000) Повторите попытку.",
    "watermark_remove_over_size":"Размер загруженного вами изображения превышает 5MB. Рекомендуется использовать наш бесплатный онлайн-компрессор изображений. Нажмите, чтобы <a class=\"jump-link\" href=\"https://www.anymp4.com/ru/image-compressor-online/\">узнать больше</a>",
    "watermark_remove_file_type_error":"Загруженный файл не является изображением, пожалуйста, загрузите его еще раз.",
    "watermark_remove_image_type_error":"Формат изображения не поддерживается. Мы поддерживаем только JPG, JPEG, PNG и BMP.",
    "watermark_remove_upload_error":"Ошибка распознавания (код ошибки: 2001), попробуйте еще раз...",
    "watermark_remove_processing":"Обработка изображения...",
    "watermark_remove_not_save":"Выбранная область не будет сохранена. Вы уверены, что хотите его обрезать?",
    "watermark_remove_back_home":"Текущий статус не будет сохранен. Вы уверены, что хотите вернуться на главную?",
    "watermark_remove_new_image":"Текущий статус не будет сохранен. Вы уверены, что хотите выбрать новое изображение?",
    "watermark_select":"Выбирать",
    "watermark_select_area":"Пожалуйста, выберите область водяного знака, которую вы хотите стереть, прежде чем нажать «Удалить».",
    "watermark_beyond_12k":"Выбранное изображение превышает разрешение 12K. К сожалению, мы не можем обработать его в настоящее время",
    "watermark_beyond_pixel_1":"Выбранное разрешение изображения превышает <span>%spx</span><span>&times;%spx</span>. Невозможно обработать, пожалуйста, выберите еще раз.",
    "watermark_beyond_pixel_2":"Посетители могут обрабатывать только изображения <span>%s</span> с разрешением выше <span>%spx</span>x<span>%spx</span>. Пожалуйста, войдите и продолжайте использовать.",
    "watermark_beyond_size_1":"Размер выбранного изображения превышает <span>%sMB</span>. Невозможно обработать, пожалуйста, выберите еще раз.",
    "watermark_beyond_size_2":"Размер выбранного изображения превышает <span>%sMB</span>, но посетители могут обрабатывать только изображения меньше, чем <span>%sMB</span>. Пожалуйста, войдите и продолжайте использовать.",
    "no_user_down":"Посетители могут загружать изображения <span>%s</span> только в исходном качестве. Пожалуйста, войдите и продолжите загрузку. Кроме того, вы можете сохранить 7-дневную историю после входа в систему. Продолжайте загружать изображения шириной или высотой <span>%spx</span>.",
    "no_down_rights":"Не удается загрузить HD-изображения в исходном качестве, обновите план! Вы также можете продолжать загружать изображения низкого качества с помощью <span>%spx</span>.",
    "error_40001":"Ошибка: 40001. Пожалуйста, свяжитесь с нами",
    "error_40099":"Ошибка: 40099. Пожалуйста, свяжитесь с нами",
    "down_btn":"Идет подготовка к загрузке, пожалуйста, подождите секунду...",
    "noRemove_down_btn":"Вы ничего не сделали для удаления водяных знаков. Выберите водяной знак, который хотите удалить, и нажмите кнопку «Удалить». Затем вы можете загрузить свое изображение.",
    "history_open":"Открывается измененное изображение, пожалуйста, подождите...",
    "maskRightsMonitor_info":"Страница для повышения привилегий была открыта в новой вкладке, и ваш план будет автоматически синхронизирован после обновления.",
    "maskLoginMonitor_info":"Целевая страница открыта, пожалуйста, авторизуйтесь на ней. После успешного входа или регистрации эта страница будет автоматически синхронизирована, пожалуйста, не закрывайте ее.",
    "photo_rights_info":"В настоящее время можно загрузить <span><i class=\"num\">2</i> HD-изображения</span> с исходным качеством. <a href=\"https://account.anymp4.com\" target=\"_blank\">Подробнее>></a>",
    "rights_original":"Чтобы включить параметр «Использовать функцию улучшения изображения для уменьшения потери качества», вам необходимо обновить свою учетную запись!",
    "Brush":"Щетка",
    "Lasso":"Лассо",
    "Polygonal":"Многоугольный",
    "Eraser":"Ластик",
    "Free":"Бесплатно",
    "More":"Более:",
    "Select":"Выбирать",
    "Remove":"Удалять",
    "BrushSize":"Размер кисти:",
    "AspectRatio":"Соотношение сторон:",
    "Upload":"Новое фото",
    "History":"История",
    "Login":"Авторизоваться",
    "MyAccount":"Мой счет",
    "Logout":"Выйти",
    "Usinghelp":"Использование справки>>",
    "Enhancer":"Используйте функцию улучшения изображения, чтобы уменьшить потерю качества.",
    "Download":"Скачать",
    "Guide":"Гид",
    "Polygonal1":"Многоугольный",
    "Polygonal_info":"Щелкните левой кнопкой мыши, чтобы определить точку за раз.",
    "Lasso1":"Лассо:",
    "Lasso_info":"Нажмите и удерживайте левую кнопку мыши, чтобы выделить область водяного знака лассо.",
    "Brush1":"Щетка:",
    "Brush_info":"Нажмите и удерживайте левую кнопку мыши, чтобы точно выбрать.",
    "Eraser1":"Ластик:",
    "Eraser_info":"Сотрите ненужные части с выделенной области.",
    "Click":"Нажмите",
    "the":"в",
    "click_info":"кнопку, чтобы начать стирание нежелательного водяного знака.",
    "PleaseUploadImages":"Пожалуйста, загрузите изображения.",
    "CropInfo":"После удаления водяного знака вы можете нажать кнопку «Обрезать», чтобы обрезать изображение перед сохранением, или нажать кнопку «Загрузить», чтобы сохранить текущее изображение напрямую.",
    "Crop":"Обрезать",
    "Back":"Назад",
    "DownloadCropped":"Скачать обрезанное",
    "Cancel":"Отмена",
    "FreeWatermarkRemover":"Удалить водяной знак бесплатно",
    "Processing":"Обработка...",
    "NewImage":"Новое изображение",
    "Retry":"Очередной раз",
    "Yes":"Да",
    "No":"Нет",
    "FailureFeedback":"Отзыв об отказе",
    "removeTip":"После выбора области водяного знака нажмите «Удалить», чтобы стереть водяной знак.",
    "rightDown":"Скачать некачественные изображения",
    "history_will":"Истекает после",
    "Expired":"(Истекший)",
	"uploadImage":"Загрузить",
    "uploadImageInfo":"Или перетащите файл изображения сюда, чтобы удалить водяной знак!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain TWO HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Неограниченный",
    "watermark_beyond_pixel_3":"Выбранное изображение превышает разрешение <span>%s&times;%s</span>, сначала обновите план.",
    "watermark_beyond_size_3":"Размер выбранного образа превышает <span>%sMB</span>. Сначала обновите свой план.",
    "no_user_login":"Новые пользователи, вошедшие в систему, могут получить ДВА преимущества загрузки исходного изображения HD.<span class=\"loginMaskbtn\">Немедленный вход в систему>></span>",
    "Upgrade":"Обновление",
    "Loading":"Загрузка…",
    "SelectAll":"Выбрать все",
    "Open":"Открыть",
    "Delete":"Удалить",
    "Clear":"Очистить недействительный",
    "noHistory":"Нет истории",
    "Close":"Закрывать",
    "buyUserInfo":"поздравляю! Вы успешно обновились. Пожалуйста, вернитесь на главную страницу и используйте этот продукт.",
    "buyNoUserInfo":"Поздравляем! Вы успешно обновились. Преимущества были привязаны к адресу электронной почты, который вы оставили при обновлении. Пожалуйста, используйте учетную запись, зарегистрированную или связанную с адресом электронной почты, чтобы <span class=\"loginMaskbtn\">войти для использования преимуществ</span>. Если вы не зарегистрировали или не связали учетную запись с адресом электронной почты, пожалуйста, <span class=\"registerMaskbtn\">используйте адрес электронной почты для регистрации учетной записи</span> или свяжите другие учетные записи с этим адресом электронной почты. почтовый адрес для использования преимуществ.",
    "GetStarted":"Начать",
    "AccessTo":"Доступ к:",
    "imagesOfwatermarkremoval":"изображения удаления водяных знаков",
    "upTo":"Вплоть до",
    "perImage":"за изображение",
    "Support":"Поддерживать",
    "resolution":"разрешающая способность",
    "PrepaidPackage":"Предоплаченный пакет",
    "PayasYouGo":"Плати как сможешь",
    "TaxIncl":"Вкл. налог.",
    "Checkout":"Проверить",
    "imagesDay":"изображений/день",
    "imagesMonthly":"изображений/ежемесячно",
    "image":"изображение",
    "images":"картинки",
    "imageSize":"Размер изображения",
    "buyInfo1":"Сторонние интеграции <span>enhancer</span>",
    "buyInfo2":"История редактирования действительна 7 дней",
    "buyInfo3":"Приоритетная обработка",
    "buyInfo4":"Круглосуточная поддержка клиентов 7x24",
    "buyInfo5":"Истек через 24 часа",
    "buyInfo6":"Нет подписки. Нет автоматического продления!",
    "buyInfo7":"Доступен для использования в любое время навсегда",
    "dayPlan":"1-дневный план",
    "Lifetime":"Срок службы",
}